import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import DOMOrderSettingsComponent from './dom-order-settings.component';
import DOMPaymentSettingsComponent from './dom-payment-settings.component';

export const DOMComponent = ({ handleInnerFormChange, selectDOMSettings, handleFormSubmit }: any) => {

  const tabItems=[
    {
        id:1,
        title:'Order Settings',
        component:<DOMOrderSettingsComponent
        selectDOMSettings={selectDOMSettings} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    },
    {
        id:2,
        title:'Payment Settings',
        component:<DOMPaymentSettingsComponent
        selectDOMSettings={selectDOMSettings} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    }
  ]
  
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
    <TabContainer tabItems={tabItems} />
 
      <div className='flex w-full justify-end items-end'>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
            type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default DOMComponent;
